export class ErrorCodesConfigurations {
    B2C_ERROR_CODES: any;
}
